import axios from 'axios';
import { CargoEntity, CargoTypeEntity, ICargoEntityAttributes } from 'Models/Entities';

interface PreviousVehicleResponse {
	id: string;
	cargoIdentification: string;
	cargoTypeId: string;
	selectedLengthId?: string;
	selectedWeightId?: string;
	selectedWidthId?: string;
	exactWeight?: number | null;
	exactWeightUnit?: string | null;
	cargoType?: {
		id: string;
		cargoMake: string;
		cargoModel: string;
	} | null;
	cargoDetails?: Array<{
		id: string;
		contactFirstName: string;
		contactLastName: string;
		contactPhone: string;
	}> | null;
}

/**
 * Returns all previous vehicles of the given user, ordered by most recently used first.
 *
 * The endpoint applies the same record-level security as the previous GraphQL query (a customer
 * can only read their own vehicles, staff can read anyone's) and returns an empty list for guests.
 */
export async function fetchPreviousVehicles(customerId: string): Promise<CargoEntity[]> {
	try {
		const response = await axios.get<PreviousVehicleResponse[]>(
			`/api/entity/UserEntity/${customerId}/latest-vehicles`,
		);

		return (response.data ?? []).map((x: PreviousVehicleResponse) => {
			const vehicleEntity = new CargoEntity(x as ICargoEntityAttributes);
			vehicleEntity.cargoType = new CargoTypeEntity(x.cargoType ?? undefined);
			return vehicleEntity;
		});
	} catch (e: any) {
		console.error(e);
		return [];
	}
}
